import { Get, Post } from 'config/apiServiceConfig'

export type GetVoucherPriorityResponseType = {
  data: {
    list: {
      id: number
      priority: number
      code: string
    }[]
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type PostVoucherPriorityRequestType = {
  payload: {
    data: {
      voucherId: number
      voucherPriority: number
    }[]
  }
}

export const getVoucherPriority = () =>
  Get<GetVoucherPriorityResponseType>({ url: '/api/promo/voucher-pinning' })

export const postVoucherPriority = ({ payload }: PostVoucherPriorityRequestType) =>
  Post({ url: '/api/promo/voucher-pinning', data: payload })

export type PromotionItemType = {
  voucher_id: number
  voucher_code: string
  voucher_created_at: string
  benefit_type: string
  targeting_type: string
  voucher_status: string
  voucher_created_by: string
  voucher_amount: number
  voucher_active: boolean
}

export type PromotionQueryType = { [key: string]: string | number | boolean | undefined }
export type PromotionPaginationType = {
  pageSize: number
  totalData: number
  totalPage: number
  currentPage: number
  currentItem: number
}
export type PromotionListResponseType = {
  content: PromotionItemType[]
  size: number
  totalElements: number
  totalPages: number
  number: number
  numberOfElements: number
}
